import Dropdown from './dropdown.vue';
import DropdownMenu from './dropdown-menu.vue';
import DropdownItem from './dropdown-item.vue';

Dropdown.Menu = DropdownMenu;
Dropdown.Item = DropdownItem;
export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/dropdown/index.js